import { z } from 'zod';

export const ConfigSchema = z.object({
  ci_color_primary: z.string(),
  ci_color_secondary: z.string(),
  ci_color_text: z.string(),
  Module: z.array(z.string()),
  App: z.array(z.string()),
  company_name: z.string(),
  logo: z.string(),
  logo_mime: z.string(),
  favicon: z.string(),
  is_testing: z.boolean(),
  gdpr_html: z.string(),
  imprint_html: z.string(),
  version: z.string(),
  email: z.string(),
  // nur public?
  street: z.string(),
  street_nr: z.string(),
  postcode: z.string(),
  city: z.string(),
  // nur privat
  license_key: z.string().optional(),
  valide_token: z.string().optional(),
  valide_refresh_token: z.string().optional(),
});

export type IConfig = z.infer<typeof ConfigSchema>;
